<template>
  <svg viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M47.92 11.38l-4.58 15a3 3 0 0 1-2.87 2.12H18.19l1.29 4.29a1 1 0 0 0 1 .71H42a1 1 0 0 1 0 2H20.44a3 3 0 0 1-2.88-2.14L9.2 5.5H1a1 1 0 0 1 0-2h9a1 1 0 0 1 1 .71l6.59 22.29h22.88a1 1 0 0 0 1-.71l4.59-15a1 1 0 0 0-.16-.88 1 1 0 0 0-.8-.41H16a1 1 0 0 1 0-2h29.1a3 3 0 0 1 2.87 3.88zM23 40.49a4 4 0 1 1-4-4 4 4 0 0 1 4 4zm-2 0a2 2 0 1 0-2 2 2 2 0 0 0 2-2zm22 0a4 4 0 1 1-4-4 4 4 0 0 1 4 4zm-2 0a2 2 0 1 0-2 2 2 2 0 0 0 2-2z"
    />
  </svg>
</template>
